module.exports = __webpack_public_path__ + "static/media/lemoon_web_logo.c43658dc.png";